var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('numeric-field',_vm._b({attrs:{"readonly":_vm.readonly,"format":_vm.format,"append-icon":"mdi-currency-eur"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}},'numeric-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }